import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { Home, Questions } from "./Components/base.js";
import { RegisterPage } from "./Components/register.js";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/register" element={<RegisterPage />}></Route>
          <Route path="/questions" element={<Questions />}></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
